<template>
    <el-dialog title="" :visible.sync="settingVisit" custom-class="setting_dialog" :close-on-click-modal="false" top="0" width="90%" @close="closeDialog">
        <div class="setting_dialog_body">
            <div class="setting_dialog_left">
                <span class="title">壁纸库</span>
                <el-menu
                    default-active="1"
                    class="el-menu-vertical-setting">
                    <el-menu-item index="1" @click="active = '1'">
                        <i class="el-icon-picture"></i>
                        <span slot="title" >静态</span>
                    </el-menu-item>
                    <el-menu-item index="2" @click="active = '2'">
                        <i class="el-icon-video-camera-solid"></i>
                        <span slot="title">动态</span>
                    </el-menu-item>
                    <el-menu-item index="3" @click="active = '3'">
                        <i class="el-icon-s-open"></i>
                        <span slot="title">纯色</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="setting_dialog_right">
                <img :src="bing.thumb" v-for="bing in bingList" @click="clickBing(bing)" v-if="active === '1'">
                <img :src="video.thumb" v-for="video in videoList" @click="clickVideo(video)" v-if="active === '2'">
                <div v-if="active === '3'" class="color-picker-container">
                    <el-color-picker v-model="bgColor" @change="clickColor" @active-change="activeChangeColor" />
                    <div class="color-display" :style="{ backgroundColor: bgColor }"></div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { bingList, videoList } from './backgroud-img'

export default {
    props: {
        'settingVisit': false
    },
    data() {
        return {
            active: '1',
            bingList: bingList,
            videoList: videoList,
            bgColor: '#f0f0f0'
        }
    },
    methods: {
        closeDialog() {
            this.$emit('update:settingVisit', false);
            this.$emit("closeSetting")
        },
        clickBing(bing) {
            this.$confirm('确认设置该图片为背景吗?', '提示', {}).then(() => {
                localStorage.removeItem('EMC_BACKGROUD_VIDEO');
                localStorage.removeItem('EMC_BACKGROUD_COLOR');
                localStorage.setItem('EMC_BACKGROUD_IMG', bing.fullSrc || bing.raw);
                this.$emit("refreshBackground");
                this.closeDialog();
            })
        },
        clickVideo(video) {
            this.$confirm('确认设置该动图为背景吗?', '提示', {}).then(() => {
                localStorage.removeItem('EMC_BACKGROUD_IMG');
                localStorage.removeItem('EMC_BACKGROUD_COLOR');
                localStorage.setItem('EMC_BACKGROUD_VIDEO', video.url);
                this.$emit("refreshBackground");
                this.closeDialog();
            })
        },
        activeChangeColor(e) {
            this.bgColor = e
        },
        clickColor(color) {
            console.log(color !== null)
            if (color !== null) {
                this.$confirm('确认设置该颜色为背景吗?', '提示', {}).then(() => {
                    localStorage.removeItem('EMC_BACKGROUD_VIDEO');
                    localStorage.removeItem('EMC_BACKGROUD_IMG');
                    localStorage.setItem('EMC_BACKGROUD_COLOR', color);
                    this.$emit("refreshBackground");
                    this.closeDialog();
                })
            }
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
    border-radius: 15px !important;
    height: 100% !important;
    margin: 0;
    padding: 0;
}

.el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.setting_dialog_body {
    width: 100%;
    height: 100% !important;
}

.setting_dialog_left {
    width: 20%;
    float: left;
    padding-right: 5px;

    .title {
        text-align: center;
        align-items: center;
        font-size: 30px;
    }

    .el-menu-vertical-setting {
        width: 100%;

        ul {
            margin: 20px 0;
        }

        span {
            font-size: 20px;
        }
    }
}

.setting_dialog_right {
    width: 78%;
    max-height: 88vh;
    overflow: auto;
    float: left;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    overflow-y: auto;
}

.setting_dialog_right img {
    width: calc(25% - 10px);
    height: auto;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
}

.color-picker-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 10px;
    margin-top: 30px;
}

.color-display {
    width: 400px;
    height: 300px;
    border-radius: 8px;
    margin-top: 100px;
}

@media (max-width: 1024px) {
    .setting_dialog_right img {
        width: calc(33.33% - 10px);
    }
}

@media (max-width: 768px) {
    .setting_dialog_right img {
        width: calc(50% - 10px);
    }
}

@media (max-width: 480px) {
    .setting_dialog_right img {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/classify/backgroundSettingDialog.vue